import { TrashClearKit } from 'education-icons';
import { Button, Link, SimpleText } from 'platform-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';

import { sendMessageFromIFrame } from 'utils/send-from-iframe';
import { SidePanelControlTypeProps } from '../typings';

export const SidePanelControlsTypeDeleteLesson = React.memo((props: SidePanelControlTypeProps) => {
    const { notifyCanBeRender, notifyCanNotBeRender } = props;
    const dispatch = useDispatch();
    const clessonId = useSelector(lessonSelectors.getCLessonId);
    const canDeleteLesson = useSelector(lessonSelectors.getCanDeleteLesson);
    const courseId = useSelector(getCurrentYearCourseId);
    const activeSubscriptionSlug = useSelector((store) => {
        return lessonSelectors.getLessonActiveSubscriptionSlug(store, { courseId });
    });

    if (!canDeleteLesson) {
        notifyCanNotBeRender();
        return null;
    }

    notifyCanBeRender();

    const deleteLesson = async () => {
        if (clessonId) {
            await dispatch(lessonViewActions.deleteCLessonAsync({ cLessonId: clessonId }));
            ym('reachGoal', 'button_delete_lesson', {
                clessonId,
                subscription_slug: activeSubscriptionSlug,
            });
            sendMessageFromIFrame('DELETE_CLESSON', { cLessonId: clessonId });
        }
    };

    return (
        <Link mix="qa_delete-lesson-link" onClick={deleteLesson} pseudo>
            <Button accent={Button.ACCENT.DANGER} icon={<TrashClearKit />} view={Button.VIEW.CLEAR}>
                <SimpleText id="lessonModal.header.deleteLesson" />
            </Button>
        </Link>
    );
});
